module.exports = __webpack_public_path__ + "static/media/default-header.34c509a1.png";